export const environment = {
  production: true,
  apiUrl: 'https://auth.devhubcentral.com.br/api/Auth',
  auth: {
    issuer: 'https://auth.devhubcentral.com.br',
    clientId: 'web_app',
    audience: 'auth_api'
  }
};
